import { defineAbility } from '@casl/ability'

export default defineAbility((can) => {
  // can('see_content', 'all');
  can('test', 'all')
  can('pipo', 'all')
  can('boom', 'all')
})
